import { LitElement, html } from 'lit';
import styles from '../shared/styles';
import { getDefaultEnv } from '../shared/utils/helpers';
import '../shared/context/app-context/AppContextProvider';
import './components/partners-page/PartnersPage';

class TenablePartners extends LitElement {
  static styles = styles;

  static properties = {
    env: { type: String },
    type: { type: String },
  };

  constructor() {
    super();
    this.env = '';
    this.type = 'partners';
  }

  connectedCallback() {
    super.connectedCallback();

    const { env } = getDefaultEnv(this.env);
    this.env = env;
  }

  render() {
    return html`
      <tenable-app-provider .value=${{ env: this.env, type: this.type }}>
        <tenable-partners-page type=${this.type}></tenable-partners-page>
      </tenable-app-provider>
    `;
  }
}

customElements.define('tenable-partners', TenablePartners);
